import { useSelector, useDispatch } from 'react-redux';
import userCoinsSlice from './userCoinsSlice';

function useUserCoins() {
    const { userCoins } = useSelector((state) => {
        return state.userCoins;
    });
    const dispatch = useDispatch();
  
    function setUserCoins(userCoins) {
      dispatch(userCoinsSlice.actions.setUserCoins(userCoins));
    }
  
    return { userCoins, setUserCoins };
}

export default useUserCoins;